import { createTheme } from '@mui/material/styles';
import { activeTheme } from './index';

const { colors } = activeTheme;

// Tema único do MUI. Usa os valores crus (não var()) porque o MUI
// calcula contraste/alpha a partir da cor.
const muiTheme = createTheme({
    typography: {
        fontFamily: 'Roboto, sans-serif',
    },
    palette: {
        brand: {
            main: colors.brand.primary,
            contrastText: colors.chrome.headerText,
        },
    },
});

export default muiTheme;
